import { ConfigInterface } from '../common/interface';

const getBaseURL = (env: string | undefined) => {
  return `https://api.au-uw2-${env}.autodesk.com`;
};

export const DEFAULT_D9_BASE_URL =
  'https://www.autodesk.com/autodesk-university';
export const DEFAULT_COMMUNITY_FUNCTIONS_URL = getBaseURL('prd');

export function generateConfig(env: string): ConfigInterface {
  let contentfulEnv: string;
  let unifiedProfileUrlEnv: string;
  let unifiedProfileEnv: string;
  let tealiumEnv: string;
  let dynatraceEnv: string;
  let userContentEnv: string;
  let khorosEnv: string;
  let communityFunctionsUrl: string;
  let loginClientEnv: string;
  let drupalBaseUrl: string = DEFAULT_D9_BASE_URL;

  switch (env) {
    case 'test':
      drupalBaseUrl = 'https://www-pt.autodesk.com/autodesk-university';
    // test config is same as PRD except for the baseUrl
    // eslint-disable-next-line no-fallthrough
    case 'prd':
      contentfulEnv = 'master';
      unifiedProfileUrlEnv = 'prd';
      unifiedProfileEnv = 'prod';
      tealiumEnv = 'prd';
      dynatraceEnv = 'prd';
      userContentEnv = 'prd';
      khorosEnv = 'prd';
      communityFunctionsUrl = DEFAULT_COMMUNITY_FUNCTIONS_URL;
      loginClientEnv = 'prod';
      break;
    case 'stg':
    case 'dev':
    default:
      drupalBaseUrl =
        'https://stg-pantheon2-au.autodesk.com/autodesk-university';
      contentfulEnv = 'stage';
      unifiedProfileUrlEnv = 'stg';
      unifiedProfileEnv = 'stage';
      tealiumEnv = 'stg';
      dynatraceEnv = 'stg';
      userContentEnv = 'stg';
      khorosEnv = 'stg';
      communityFunctionsUrl = getBaseURL('stg');
      loginClientEnv = 'stg';
      break;
  }

  return {
    D9_BASE_URL: drupalBaseUrl,
    COMMUNITY_FUNCTIONS_URL: communityFunctionsUrl,
    USER_PROFILE_URL: getBaseURL(userContentEnv),
    USER_CONTENT_URL: getBaseURL(userContentEnv),
    KHOROS_API: getBaseURL(khorosEnv),
    CONTENTFUL_EXEC_ENVIRONMENT: contentfulEnv,
    UNIFIED_PROFILE_URL_ENV: unifiedProfileUrlEnv,
    UNIFIED_PROFILE_ENVIRONMENT: unifiedProfileEnv,
    TEALIUM_ENV: tealiumEnv,
    DYNATRACE_ENV: dynatraceEnv,
    LANGUAGE_NAMES: {
      en: 'English',
      de: 'Deutsch',
      ja: '日本語',
      fr: 'Français',
      es: 'Español',
      ru: 'Русский',
      'zh-hans': '简体中文',
      ko: '한국어',
    },
    CACHE_TTL: {
      default: 60 * 60 * 1000,
      d9HeaderFooter: 6 * 60 * 60 * 1000,
    },
    BRIGHTCOVE: {
      projectId: '10846',
      accountId: '6057940518001',
    },
    // TODO: Suspect these process.env values (and EXEC_ENVIRONMENT below) are always blank and unnecessary
    // the values are set via authOverrides in aurr/index.js, or passed in via aurr_environment in same file
    LOGIN_REDIRECT_URL: process.env.LOGIN_REDIRECT_URL || '',
    LOGIN_CLIENT_ID: process.env.LOGIN_CLIENT_ID || '',
    LOGIN_CLIENT_ENV: process.env.LOGIN_CLIENT_ENV || loginClientEnv,
  };
}

const config = generateConfig(process.env.EXEC_ENVIRONMENT || 'prd');
export { config };
